<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TheNotificationPermissionBar',
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      hasGrantedNotificationPermission:
        'notification/hasGrantedNotificationPermission',
    }),
  },
  methods: {
    ...mapActions({
      askNotificationPermission: 'notification/askNotificationPermission',
    }),
  },
}
</script>

<template>
  <article
    v-if="!hasGrantedNotificationPermission"
    class="w-100"
    style="z-index: 6"
  >
    <v-alert tile color="blue" text class="mb-0 text-align-center">
      <section class="d-flex justify-center align-center">
        <v-icon class="mr-4" color="blue" left>mdi-bell-alert</v-icon>
        <h4
          :class="
            (isMobileViewPort ? 'body-2' : 'font-weight-medium',
            isDarkMode ? '' : 'black--text')
          "
        >
          Please enable notification permissions on your browser
        </h4>

        <v-btn
          class="ml-4 white--text"
          color="blue"
          depressed
          :small="isMobileViewPort"
          @click="askNotificationPermission"
        >
          Enable Permissions
        </v-btn>
      </section>
    </v-alert>
  </article>
</template>
